import _objectSpread from "/Users/safepal/Desktop/work/spd/feedback-console/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.error.to-string.js";
import axios from "axios";
import qs from "qs";
import { ElMessage as Message, ElLoading as Loading } from "element-plus";
import { jsonp } from "vue-jsonp";
import { isEqual } from "lodash-es";
var errorHandler = new Proxy(Object.create(null), {
  get: function get(target, code) {
    if (target[code]) return target[code];
    var msgClosed = true;
    var closeFn;

    var handler = function handler(msg) {
      if (msgClosed === false) {
        var _closeFn;

        (_closeFn = closeFn) === null || _closeFn === void 0 ? void 0 : _closeFn();
      }

      msgClosed = false;
      closeFn = Message({
        onClose: function onClose() {
          msgClosed = true;
          closeFn = null;
        },
        message: msg,
        type: "error"
      });
    };

    target[code] = handler;
    return handler;
  }
});

var getErrorHandler = function getErrorHandler(code) {
  return errorHandler[code];
}; // 计算baseUrl


var baseUrl = '/api/survey/'; // 创建axios实例

var service = axios.create({
  // 接口开发环境还是生产环境的配置地址
  baseURL: baseUrl,
  // send cookies when cross-domain requests
  withCredentials: true,
  // 请求超时时间
  timeout: 30000
}); // 存储所有的请求标致和拒绝请求的方法

var pending = []; // 这个是控制取消请求的

var CancelToken = axios.CancelToken; // 检查且删掉同样的请求

var removePending = function removePending(config) {
  for (var p in pending) {
    if (pending[p].u === config.url + "&" + config.method && isEqual(config.data || config.params, pending[p].reqData)) {
      // 当前请求在数组中存在时，执行函数体
      // 执行取消操作
      pending[p].f(); // 把这条记录从数组中移除

      pending.splice(p, 1);
    }
  }
}; // 创建loading对象


var loading; // 显示loading

function showLoading(target, text) {
  if (!loading) {
    loading = Loading.service({
      lock: true,
      text: text || "Loading...",
      background: "rgba(255, 255, 255, 0.5)",
      target: target || "body"
    });
  }
} // 隐藏loading


function hideLoading() {
  loading.close();
  loading = null;
} // request 拦截器


service.interceptors.request.use(function (config) {
  // 在一个ajax发送前执行一下取消操作
  removePending(config);
  config.cancelToken = new CancelToken(function (c) {
    pending.push({
      u: config.url + "&" + config.method,
      f: c,
      reqData: config.data || config.params
    });
  }); // 判断当前请求是否设置了显示Loading

  if (config.loading && config.loading.show === true) {
    showLoading(config.loading.target, config.loading.text);
  }

  return config;
}, function (error) {
  return Promise.reject(error);
}); // respone拦截器

service.interceptors.response.use(function (response) {
  // 判断当前请求是否设置了显示Loading
  if (response.config.loading && response.config.loading.show === true) {
    hideLoading();
  } // 在一个ajax响应后再执行一下取消操作，把已经完成的请求从pending中删除


  removePending(response.config);

  if (response.status !== 200) {
    throw new Error(response.statusText);
  } // 先默认全部可以请求成功
  // if (response.data.code !== 0) {
  //   // 直接过去返回数据，比如数据流等返回
  //   if(response.config.meta && response.config.meta.unInterceptResponse){
  //     return response;
  //   }
  //   if (!response.config.isShowCustomizeError) {
  //     const errorHandler = getErrorHandler(response.data.code);
  //     errorHandler(response.data.message);
  //   }
  //   const error = new Error();
  //   Object.assign(error, response.data);
  //   error.message = response.data.message;
  //   error.response = response;
  //   return Promise.reject(error);
  // } else {
  //   return response;
  // }


  return response.data;
}, function (error) {
  var _error$response;

  // 判断当前请求是否设置了显示Loading
  if (error.config.loading && error.config.loading.show === true) {
    hideLoading();
  }

  var messages = {
    500: 'Server exception ',
    401: 'No access ',
    404: 'The request path does not exist!'
  };
  var status = (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status; // 错误提醒

  switch (status) {
    case 500:
    case 401:
    case 404:
      Message({
        message: messages[status],
        type: "error"
      });
      break;

    default:
      ElMessage.error('Request service exception');
      break;
  } // 错误提醒


  error.message = status ? messages[status] : error.message;
  return Promise.reject(error);
});
export default {
  get: function get(url, params) {
    var loading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return service({
      method: "get",
      url: url,
      params: params,
      loading: loading
    }).then(function (res) {
      return res.data;
    });
  },
  postJSON: function postJSON(url, data) {
    var loading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var options = arguments.length > 4 ? arguments[4] : undefined;
    return service(_objectSpread({
      method: "post",
      url: url,
      data: data,
      loading: loading,
      // 设置请求头
      headers: headers
    }, options)).then(function (response) {
      return response.data;
    });
  },
  post: function post() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        url = _ref.url,
        param = _ref.param,
        _ref$loading = _ref.loading,
        loading = _ref$loading === void 0 ? {} : _ref$loading,
        _ref$headers = _ref.headers,
        headers = _ref$headers === void 0 ? {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
    } : _ref$headers,
        options = _ref.options;

    return service(_objectSpread({
      method: "post",
      url: url,
      // 将请求数据转为application/x-www-form-urlencoded
      data: qs.stringify(param),
      loading: loading,
      // 设置请求头
      headers: headers
    }, options)).then(function (response) {
      return response.data;
    });
  },
  form: function form(url, formdata) {
    return service({
      method: "post",
      url: url,
      data: formdata
    }).then(function (response) {
      return response.data;
    });
  },
  jsonp: jsonp,
  define: function define(options) {
    return service(options);
  }
};